<template>
  <div>
    <div class="appServiceResourceAzure-title">
      <div>{{ $t("RAM.Azure.appService.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:appServiceResourceAzure:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="appServiceResourceAzure-top">
      <app-service-resource-azure-search
        ref="search"
      ></app-service-resource-azure-search>
    </div>
    <table-app-service-resource-azure></table-app-service-resource-azure>
  </div>
</template>

<script>
import AppServiceResourceAzureSearch from "../app_service/AppServiceResourceAzureSearch";
import TableAppServiceResourceAzure from "../app_service/TableAppServiceResourceAzure";

export default {
  name: "AppServiceResourceAzure",
  components: {
    AppServiceResourceAzureSearch,
    TableAppServiceResourceAzure
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureAppService({
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "应用程序服务.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.appServiceResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.appServiceResourceAzure-title > div:nth-child(1) {
  float: left;
}
.appServiceResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.appServiceResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/app_service/AppServiceResourceAzure.vue